import type { RichTextBlock as RichTextBlockType } from "@/types";
import { renderMarkdown } from "@/lib/markdown";

export function RichTextBlock({ block }: { block: RichTextBlockType }) {
  const html = renderMarkdown(block.props.body_md);
  return (
    <section className="block block--rich-text">
      {block.props.heading ? <h2>{block.props.heading}</h2> : null}
      <div className="prose" dangerouslySetInnerHTML={{ __html: html }} />
    </section>
  );
}
